import React, { useState } from 'react';
import ssoService from '../ssoService';

interface SSOLoginButtonProps {
  className?: string;
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

export const SSOLoginButton: React.FC<SSOLoginButtonProps> = ({
  className = '',
  variant = 'primary',
  size = 'md',
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleSSOLogin = async (): Promise<void> => {
    setLoading(true);
    setError(null);

    try {
      const authorizationUrl = await ssoService.initiateSSOLogin();

      const currentPath = window.location.pathname;
      if (currentPath !== '/login') {
        localStorage.setItem('sso_redirect_to', currentPath);
      }

      window.location.href = authorizationUrl;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to initiate SSO login';
      setError(errorMessage);
      setLoading(false);
    }
  };

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };

  const variantClasses = {
    primary: 'bg-[var(--color-primary-500)] text-white hover:opacity-90',
    outline:
      'border-2 border-[var(--color-primary-500)] text-[var(--color-primary-500)] hover:bg-[var(--color-primary-500)] hover:text-white',
    ghost: 'text-[var(--color-primary-500)] hover:bg-[var(--color-neutral-200)]',
  };

  return (
    <div className="flex flex-col gap-2">
      <button
        onClick={handleSSOLogin}
        disabled={loading}
        className={`rounded-lg font-medium transition-colors ${sizeClasses[size]} ${variantClasses[variant]} ${className} disabled:opacity-50 disabled:cursor-not-allowed`}
        type="button"
      >
        {loading ? 'Redirecting...' : 'Sign in'}
      </button>
      {error && (
        <p className="text-xs" style={{ color: 'var(--color-error-500)' }}>
          {error}
        </p>
      )}
    </div>
  );
};

